<app-input-label [inputId]="id" [inputName]="name" [helpTooltipText]="helpTooltipText"></app-input-label>

<input
  [id]="id"
  [name]="name"
  class="input"
  type="text"
  [disabled]="true"
  [mask]="inputMask || ''"
  [(ngModel)]="value"
>
